import api from './../../Api.js';

function Badge_helper(props) {
  this.props = props;
}

Badge_helper.prototype.getBadgesByUser = async function (userId) {
  try {
    var res = await api.getBadgesByUser(userId);
    this.props.dispatch({ type: "SET_BADGES", data: res.data });
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: [] };
  }
}

Badge_helper.prototype.getBadgesByClassroom = async function (classroomId) {
  try {
    var res = await api.getBadgesByClassroom(classroomId);
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: [] };
  }
}

Badge_helper.prototype.getBadgeTypes = async function () {
  try {
    var res = await api.getBadgeTypes();
    this.props.dispatch({ type: "SET_BADGE_TYPES", data: res.data });
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: [] };
  }
}

Badge_helper.prototype.getBadgeCount = async function (userId) {
  try {
    var res = await api.getBadgeCount(userId);
    this.props.dispatch({ type: "SET_BADGE_COUNT", data: res.data.total });
    return { status: 200, data: res.data.total };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: 0 };
  }
}

Badge_helper.prototype.getLeaderboard = async function (classroomId, limit) {
  try {
    var res = await api.getBadgeLeaderboard(classroomId, limit);
    this.props.dispatch({ type: "SET_BADGE_LEADERBOARD", data: res.data });
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: [] };
  }
}

Badge_helper.prototype.checkProgress = async function (data) {
  try {
    var res = await api.checkBadgeProgress(data);
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: null };
  }
}

Badge_helper.prototype.getStudentProfile = async function (classroomId, userId) {
  try {
    var res = await api.getStudentBadgeProfile(classroomId, userId);
    this.props.dispatch({ type: "SET_BADGES", data: res.data.badges });
    this.props.dispatch({ type: "SET_BADGE_COUNT", data: res.data.totalBadges });
    this.props.dispatch({ type: "SET_CERTIFICATES", data: res.data.certificates });
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: null };
  }
}

Badge_helper.prototype.getCertificatesByUser = async function (userId) {
  try {
    var res = await api.getCertificatesByUser(userId);
    this.props.dispatch({ type: "SET_CERTIFICATES", data: res.data });
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: [] };
  }
}

Badge_helper.prototype.getCertificateCount = async function (userId) {
  try {
    var res = await api.getCertificateCount(userId);
    this.props.dispatch({ type: "SET_CERTIFICATE_COUNT", data: res.data.total });
    return { status: 200, data: res.data.total };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: 0 };
  }
}

Badge_helper.prototype.verifyCertificate = async function (code) {
  try {
    var res = await api.verifyCertificate(code);
    return { status: 200, data: res.data };
  } catch (error) {
    return { status: error.response ? error.response.status : 500, data: null };
  }
}

export default Badge_helper;
